module.exports = __webpack_public_path__ + "static/media/logo.bbcebc86.svg";